
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lyceen/metiers/a1connect-1",
      function () {
        return require("private-next-pages/lyceen/metiers/a1connect-1.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lyceen/metiers/a1connect-1"])
      });
    }
  